import { getAPI } from "./axios-base";

export default class RestResourceBookings {
  getBookings(params: any) {
    return getAPI.get(`api/rest/v1/bookings`, { params });
  }
}
